import * as React from 'react'

import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalDocuments?: number
  filename?: string
  hasSignature?: boolean
  loading: boolean
  onSubmit: () => void
  onClose: () => void
}

const TrashBinModal = ({
  totalDocuments = 1,
  filename,
  hasSignature = false,
  loading,
  onSubmit,
  onClose,
}: Props) => {
  const isDisabled = loading

  return (
    <Modal
      title={i18n.t('documents.move_to_trash_bin_modal.title')}
      illustration="delete"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button
            iconName={loading ? 'delete' : undefined}
            type="negative"
            disabled={isDisabled}
            loading={loading}
            submit
          >
            {i18n.t('documents.move')}
          </Button>
        </>
      }
    >
      <Box gap="s16">
        <Text.Normal>
          {i18n.tp('documents.move_to_trash_bin_modal.description', {
            name: filename,
            count: totalDocuments,
          })}
        </Text.Normal>

        {hasSignature && (
          <Alert color="warning">
            {i18n.tp('documents.move_to_trash_bin_modal.alert', { count: totalDocuments })}
          </Alert>
        )}
      </Box>
    </Modal>
  )
}

export default observer(TrashBinModal)
